import React from 'react';
import { StyledSvgIcon } from '../icon.styles';
import { customIconsPropTypes } from './customicons.propTypes';
const HamburgerMenuIcon = ({ fontSize, color, sx, title }) => (
  <StyledSvgIcon
    fontSize={fontSize}
    color={color}
    titleAccess={title}
    data-testid={title}
    aria-label={title}
    sx={sx}
  >
    <svg viewBox="0 0 45 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1 0.692383C0.447715 0.692383 0 1.1401 0 1.69238C0 2.24467 0.447715 2.69238 1 2.69238V0.692383ZM1 2.69238H45V0.692383H1V2.69238Z"
        fill="currentColor"
      />
      <path
        d="M1 10C0.447715 10 0 10.4477 0 11C0 11.5523 0.447715 12 1 12V10ZM1 12H45V10H1V12Z"
        fill="currentColor"
      />
      <path
        d="M1 19.3079C0.447715 19.3079 0 19.7556 0 20.3079C0 20.8601 0.447715 21.3079 1 21.3079V19.3079ZM1 21.3079H45V19.3079H1V21.3079Z"
        fill="currentColor"
      />
    </svg>
  </StyledSvgIcon>
);
export default HamburgerMenuIcon;

HamburgerMenuIcon.propTypes = customIconsPropTypes;
